import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import LoginForm from '@/components/LoginForm'
import Main from '@/components/Main'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  // en mode history ne pas oublier d'utiliser home.php pour TOUS les templates
  // templates/template/files/ > Alternate template settings
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'LoginForm',
      component: LoginForm,
      props: { searchPage: false }
    },
    {
      path: '/',
      name: 'Home',
      component: Main,
      props: { searchPage: false }
    },
    {
      path: '/en',
      name: 'Home',
      component: Main,
      props: { searchPage: false }
    },
    {
      path: '/membres/*',
      name: 'Membre',
      component: Main,
      props: { searchPage: false }
    },
    // {
    //   path: ':lang/membres/:membre',
    //   name: 'MembreEn',
    //   component: Main,
    //   props: { searchPage: false }
    // },    
    {
      path: '/recherche/liste',
      name: 'Recherche',
      component: Main,
      props: { searchPage: true, searchViewMode: 'list' }
    },
    {
      path: '/en/recherche/liste',
      name: 'Recherche',
      component: Main,
      props: { searchPage: true, searchViewMode: 'list' }
    },

    {
      path: '/arts-en-residence/carte',
      name: 'Recherche',
      component: Main,
      props: { searchPage: true, searchViewMode: 'map' }
    },
    {
      path: '/en/arts-en-residence/carte',
      name: 'Recherche',
      component: Main,
      props: { searchPage: true, searchViewMode: 'map' }
    },

    {
      path: '/*',
      name: 'Page',
      component: Main,
      props: { searchPage: false }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
  }

})

router.beforeEach((to, from, next) => {
  if (!global.isMobile) {
    $('html, body').animate({
      scrollTop: 0,
    }, 600, function() {
      next()
    })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js